export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">联系我们</h2>
        <p className="text-sm text-foreground-600 max-w-lg mx-auto mb-8 md:mb-10">
          如果您有独家爆料线索、商务合作需求或对黑料视频有任何建议，欢迎通过以下方式与我们取得联系
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          <div className="bg-background-100 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-200 group cursor-pointer">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-200 transition-colors">
              <i className="ri-mail-line text-primary-600 text-xl"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿爆料</h3>
            <p className="text-xs text-foreground-500">tips@heiliaotv.com</p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-200 group cursor-pointer">
            <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-accent-200 transition-colors">
              <i className="ri-briefcase-4-line text-accent-600 text-xl"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-500">biz@heiliaotv.com</p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-200 group cursor-pointer">
            <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-secondary-200 transition-colors">
              <i className="ri-question-answer-line text-secondary-700 text-xl"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
            <p className="text-xs text-foreground-500">feedback@heiliaotv.com</p>
          </div>
        </div>

        <p className="text-xs text-foreground-500 mt-6">
          工作时间：周一至周日 9:00 - 22:00 · 通常2小时内回复
        </p>
      </div>
    </section>
  );
}